export default {
      id: "logo_footer-usage",
      viewBox: "0 0 165 145",
      url: "../dist/images/" + "sprite.svg#logo_footer-usage",
      toString: function () {
        return this.url;
      }
    }